import { Grid } from '@mui/material';
import * as React from 'react';
import { Icon } from 'semantic-ui-react';
import styles from './Pagination.module.scss'

interface IPaginationProps {
    resultsCount: number;
    resultsSkip: number;
    callSearchApi: any;
}
interface IPaginationState {
    nextButtonDisabled: boolean;
    perviousButtonDisabled: boolean;
    currNumber: number;
    total: number;
}

export class Pagination extends React.Component<IPaginationProps, IPaginationState>{
    constructor(props: IPaginationProps) {
        super(props);

        this.state = {
            currNumber: this.props.resultsSkip == 0 ? 1 : ((this.props.resultsSkip / 10) + 1),
            total: Math.ceil((this.props.resultsCount / 10)),
            nextButtonDisabled: (this.props.resultsSkip == 0 ? 1 : ((this.props.resultsSkip / 10) + 1)) == (Math.ceil((this.props.resultsCount / 10))) ? true : false, 
            perviousButtonDisabled: (this.props.resultsSkip == 0 ? 1 : ((this.props.resultsSkip / 10) + 1)) == 1 ? true : false 
        }

    }

    componentDidMount() {
        this.generatePageNumbers();
    }

    componentDidUpdate(prevProps: IPaginationProps, prevState: IPaginationState) {
        if (prevProps != this.props) {
            this.setState({
                currNumber: this.props.resultsSkip == 0 ? 1 : ((this.props.resultsSkip / 10) + 1),
                total: Math.ceil((this.props.resultsCount / 10)),
                nextButtonDisabled: this.state.currNumber == this.state.total ? true : false,
                perviousButtonDisabled: this.state.currNumber == 1 ? true : false
            });
        }
    }

    public render() {
        return (
            <Grid container spacing={1} className={styles.pagination}>
                <Grid item xs={1} className={this.state.perviousButtonDisabled ? styles.arrowDisabled : styles.arrow} onClick={() => this.perviousClick()}>
                    <Icon name='angle left' size='big' disabled={this.state.perviousButtonDisabled} />
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={8} className={styles.middlePagination}>
                    {this.generatePageNumbers()}
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={1} className={this.state.nextButtonDisabled ? styles.arrowDisabled : styles.arrow}>
                    <Icon name='angle right' size='big' disabled={this.state.nextButtonDisabled} onClick={() => this.nextClick()} />
                </Grid>
            </Grid>
        );
    }

    private nextClick() {
        let currentNumber = this.props.resultsSkip == 0 ? 1 : ((this.props.resultsSkip / 10) + 1);
        let total = Math.ceil((this.props.resultsCount / 10));
        if (currentNumber != total) {
            this.props.callSearchApi(currentNumber + 1);
        }
    }

    private perviousClick() {
        let currentNumber = this.props.resultsSkip == 0 ? 1 : ((this.props.resultsSkip / 10) + 1);

        if (currentNumber != 1) {
            this.props.callSearchApi(currentNumber - 1);
        }
    }

    private first(pageNumbers: string[]) {
        for (let index = 1; index <= 3; index++) {
            pageNumbers.push(index.toString());
        }

        return pageNumbers;
    }

    private last(pageNumbers: string[], total: number) {
        for (let index = total - 1; index <= total; index++) {
            pageNumbers.push(index.toString());
        }

        return pageNumbers;
    }

    private generatePageNumbers() {

        let pageNumbers: string[] = [];
        let currentNumber = this.props.resultsSkip == 0 ? 1 : ((this.props.resultsSkip / 10) + 1);
        let total = Math.ceil((this.props.resultsCount / 10));

        if (total <= 10) {
            for (let index = 1; index <= total; index++) {
                pageNumbers.push(index.toString());
            }
        } else {
            if (currentNumber < 5 || currentNumber >= total - 4) {
                for (let index = 1; index <= 5; index++) {
                    pageNumbers.push(index.toString());
                }
                pageNumbers.push('...');
                for (let index = total - 4; index <= total; index++) {
                    pageNumbers.push(index.toString());
                }
            }
            else {
                this.first(pageNumbers);
                pageNumbers.push('...');
                for (let index = currentNumber - 1; index <= currentNumber + 1; index++) {
                    pageNumbers.push(index.toString());
                }
                pageNumbers.push('...');
                this.last(pageNumbers, total);
            }
        }

        return this.generateData(pageNumbers, currentNumber.toString());
    }

    private generateData(pageNumbers: string[], currentNumber: string) {
        return pageNumbers.map((number, index) => {
            let cn = (number == currentNumber) ? styles.selected : styles.number;
            return <button className={cn} key={index} onClick={() => this.props.callSearchApi(number)}>{number}</button>;
        })
    }
}